// apps/booking-frontend/src/components/SubscriptionBanner.tsx
import React from 'react';

const SubscriptionBanner: React.FC = () => {
  // 簡單顯示當前版本
  const currentPlan = '基礎版';

  return (
    <div className="bg-white dark:bg-slate-800 shadow rounded-lg p-6 mb-8">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
        訂閱方案
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        當前方案：<span className="font-semibold text-brand-600 dark:text-brand-400">{currentPlan}</span>
      </p>
    </div>
  );
};

export default SubscriptionBanner;
